import { useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ServicesSection from './components/ServicesSection';
import StaffSection from './components/StaffSection';
import AccessSection from './components/AccessSection';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';

const SCHEMA_LD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#business`,
      "name": "さくらデイサービス",
      "description": "さくらデイサービスは東京都のデイサービス（通所介護）施設です。介護福祉士・理学療法士が在籍し、入浴・機能訓練・送迎サービスを提供しています。",
      "url": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/`,
      "telephone": "03-0000-0000",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "〒000-0000 東京都○○区○○1-2-3",
        "addressLocality": "東京都",
        "addressRegion": "東京都",
        "postalCode": "000-0000",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 35.6762,
        "longitude": 139.6503
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
          "opens": "08:30",
          "closes": "17:30"
        }
      ],
      "priceRange": "¥¥",
      "servesCuisine": "介護・デイサービス",
      "sameAs": []
    },
    {
      "@type": "WebPage",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#webpage`,
      "url": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/`,
      "name": "さくらデイサービス｜東京都のデイサービス・通所介護",
      "description": "さくらデイサービスは東京都のデイサービス（通所介護）施設です。介護福祉士・理学療法士が在籍し、入浴・食事・機能訓練などのサービスを受けられる介護保険サービスです。要介護・要支援の方のご相談はお気軽に。",
      "inLanguage": "ja",
      "isPartOf": {
        "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/#business`
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "デイサービスとはどのようなサービスですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "デイサービス（通所介護）は、要介護・要支援の認定を受けた方が日帰りで施設に通い、入浴・食事・機能訓練などのサービスを受けられる介護保険サービスです。"
          }
        },
        {
          "@type": "Question",
          "name": "利用するにはどうすればよいですか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "まずは介護保険の要介護・要支援認定を受けていただく必要があります。認定後、担当のケアマネジャーにご相談いただくか、直接さくらデイサービスまでお電話でお問い合わせください。"
          }
        },
        {
          "@type": "Question",
          "name": "送迎サービスはありますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "はい、ご自宅から施設までの送迎サービスを提供しております。詳しくはお電話にてご確認ください。"
          }
        }
      ]
    }
  ]
};

export default function HomePage() {
  useEffect(() => {
    const scriptId = 'schema-ld-home';
    if (document.getElementById(scriptId)) return;
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(SCHEMA_LD);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ServicesSection />
        <StaffSection />
        <AccessSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
